// Import Icons
import unauthorized from "../assets/images/unauthorized.svg";
import unauthenticated from "../assets/images/unauthenticated.svg";
import flat_illustration from "../assets/images/flat_illustration.svg";
import wand from "../assets/images/wand.svg";
import clip_default from "../assets/images/clip_default.svg";
import tag_annotation from "../assets/images/tag_annotation.svg";
import tag_note from "../assets/images/tag_note.svg";
import tag_bookmark from "../assets/images/tag_bookmark.svg";
import tag_translation from "../assets/images/tag_translation.svg";
import tag_transcription from "../assets/images/tag_transcription.svg";
import tag_clip from "../assets/images/tag_clip.svg";
import user_default from "../assets/images/user.svg";
import film from "../assets/images/film.svg";
import context_menu from "../assets/images/context_menu.svg";
import back from "../assets/images/back.svg";
import delete_icon from "../assets/images/delete.svg";
import tip from "../assets/images/tips_icon.svg";
import SpeakOutLoudImg from "../assets/images/SpeakOutLoudImg.png";
import ConfirmationPic from "../assets/images/ConfirmationPic.png";
import girlWithLove from "../assets/images/girl-showing-love.png";
import extTestCompleted from "../assets/images/ext_test_completed.svg";
import firstTaskGuideArrow from "../assets/images/firstTaskGuideArrow.svg";
import taskCtrlText from "../assets/images/taskCtrlText.svg";
import noReponses from "../assets/images/test_noresponse.svg";
import mouseMapClick from "../assets/images/mouse_map/click.svg";
import mouseMapFirstMove from "../assets/images/mouse_map/firstmove.svg";
import mouseMapLastMove from "../assets/images/mouse_map/lastmove.svg";
import mouseMapOnGoing from "../assets/images/mouse_map/on-going.svg";
import mouseMapFirstClick from "../assets/images/mouse_map/firstClick.svg";
import mouseMapFirstHover from "../assets/images/mouse_map/firstHover.svg";
import uploadSuccessGif from "../assets/images/upload-success.gif";
import skeleton from "../assets/images/skeleton.png";
import userInterviews from "../assets/images/user-interviews.svg";
import focusGroup from "../assets/images/dd-focusgroup.svg";
import individual from "../assets/images/dd-individual.svg";
import dyad from "../assets/images/dd-dyad.svg";
import triad from "../assets/images/dd-triad.svg";
import moderatedInterview from "../assets/images/moderated-interview.svg";
import moderatedFocusGroup from "../assets/images/moderated-focus-group.svg";
import iso from "../assets/images/iso.svg";
import soc2 from "../assets/images/soc2.svg";
import gdbr from "../assets/images/gdbr.svg";
import hippa from "../assets/images/hippa.svg";
import confirmationSteps from "../assets/images/confirmationSteps.png";
import confirmationVector from "../assets/images/confirmation_vector.png";
import wifiMobile from "../assets/images/wifiMobile.png";
import quiteArea from "../assets/images/quiteArea.png";
import micMobile from "../assets/images/micMobile.png";
import whySpeak from "../assets/images/whySpeak.png";
import inviteExpired from "../assets/images/invite-expired.svg";
import inviteSuccess from "../assets/images/invite-success.svg";
import audioNote from "../assets/images/audionote.svg";
import translateAnimation from "../assets/images/loading-translation.gif";

// Export Icons
export const UNAUTHORIZED = unauthorized;
export const UNAUTHENTICATED = unauthenticated;
export const FLAT_ILLUSTRATION = flat_illustration;
export const WAND = wand;
export const CLIP_DEFAULT = clip_default;
export const TAG_ANNOTATION = tag_annotation;
export const TAG_NOTE = tag_note;
export const TAG_BOOKMARK = tag_bookmark;
export const TAG_TRANSLATION = tag_translation;
export const TAG_TRANSCRIPTION = tag_transcription;
export const TAG_CLIP = tag_clip;
export const USER_DEFAULT = user_default;
export const FILM = film;
export const CONTEXT_MENU = context_menu;
export const BACK = back;
export const DELETE_ICON = delete_icon;
export const TIP = tip;
export const SPEAK_OUT_LOAD = SpeakOutLoudImg;
export const CONFIRMATION_PIC = ConfirmationPic;
export const GIRLWITHLOVE = girlWithLove;
export const EXT_TEST_COMPLETED = extTestCompleted;
export const FIRST_TASK_GUIDE_ARROW = firstTaskGuideArrow;
export const TASK_CTRL_TEXT = taskCtrlText;
export const NO_RESPONSES = noReponses;
export const MOUSE_MAP_CLICK = mouseMapClick;
export const MOUSE_MAP_FIRST_MOVE = mouseMapFirstMove;
export const MOUSE_MAP_LAST_MOVE = mouseMapLastMove;
export const MOUSE_MAP_ON_GOING = mouseMapOnGoing;
export const MOUSE_MAP_FIRST_CLICK = mouseMapFirstClick;
export const MOUSE_MAP_FIRST_HOVER = mouseMapFirstHover;
export const UPLOAD_SUCCESS_GIF = uploadSuccessGif;
export const SKELETON = skeleton;
export const DYAD_ICON = dyad;
export const TRIAD_ICON = triad;
export const INDIVIDUAL_ICON = individual;
export const FOCUS_GROUP_ICON = focusGroup;
export const USER_INTERVIEWS_ICON = userInterviews;
export const MODERATED_INTERVIEW = moderatedInterview;
export const MODERATED_FOCUS_GROUP = moderatedFocusGroup;
export const ISO = iso;
export const SOC2 = soc2;
export const GDBR = gdbr;
export const HIPPA = hippa;
export const CONFIRMATION_STEPS = confirmationSteps;
export const CONFIRMATION_VECTOR = confirmationVector;
export const WIFI_MOBILE = wifiMobile;
export const QUITE_AREA = quiteArea;
export const MIC_MOBILE = micMobile;
export const WHY_SPEAK = whySpeak;
export const INVITE_EXPIRED = inviteExpired;
export const INVITE_SUCCESS = inviteSuccess;
export const AUDIO_NOTE = audioNote;
export const TRANSLATE_ANIMATION = translateAnimation;
